import React from "react";
import MainAttendanceReport from "./MainAttendanceReport";
import MainDateWiseReport from "./MainDateWiseReport";



const TimeWiseAttendanceReport = () =>{
    return (
        <div>
            <MainDateWiseReport timeWise type="time"/>
            <div className="card styled-report-card p-3">
                <h6>Time Wise Report</h6>
                <hr/>
                <MainAttendanceReport/>
            </div>
        </div>
    )
};
export default TimeWiseAttendanceReport;